'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import { FiRefreshCw } from "react-icons/fi";
import Ende from '@/components/home-page/body/end';
import NavBar from '@/components/header/NavBar';
import End from '@/components/footer/end';
import { useLocale } from 'next-intl';
const ContactForm: React.FC = () => {
  const t = useTranslations('contact');
 const th = useTranslations('Padel-Master-The-Game-Refund-Policy');
 const slide = {
   src_en: "/hero-court/padel-court.avif",
   src_ar: "/hero-court/ملعب-بادل.avif",
   src_de: "/hero-court/padelplatz.avif",
   src_es: "/hero-court/pista-de-padel.avif",
   src_fr: "/hero-court/terrain-de-padel.avif",
   src_it: "/hero-court/campo-da-padel.avif",
   src_nl: "/hero-court/padelbaan.avif",
   src_pt: "/hero-court/quadra-de-padel.avif",
   src_ru: "/hero-court/padel-kort.avif",
   src_sv: "/hero-court/padelbana.avif",
   alt: "Padel Court"
 };
 
   const locales = ['en','ar','de','es','fr','it','nl','pt','ru','sv'] as const;
   type Locale = typeof locales[number];
   const locale = useLocale() as Locale;
   const key = `src_${locale}` as keyof typeof slide;
   const bgImage = slide[key] || slide.src_en;
  return (
    <>
      <style>{`
        @keyframes pulse-ring {
          0% { box-shadow: 0 0 0 0px rgba(255,255,255,0.45); }
          100% { box-shadow: 0 0 0 18px rgba(255,255,255,0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes fadeSlideUp {
          0% { opacity: 0; transform: translateY(40px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .btn-card { animation: pulse-ring 2s ease-out infinite; }
        .btn-crypto { animation: pulse-ring 2s ease-out infinite 1s; }
        .book-float { animation: float 4s ease-in-out infinite; }
        .fade-up-1 { animation: fadeSlideUp 0.8s ease-out 0.2s both; }
        .fade-up-2 { animation: fadeSlideUp 0.8s ease-out 0.5s both; }
        .fade-up-3 { animation: fadeSlideUp 0.8s ease-out 0.8s both; }
        .pay-btn {
          border: 4px solid white;
          color: white;
          border-radius: 9999px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 8px;
          background: rgba(0,0,0,0.4);
          backdrop-filter: blur(8px);
          transition: all 0.3s ease-in-out;
          cursor: pointer;
        }
        .pay-btn:hover {
          background: white;
          color: black;
          transform: scale(1.12);
          box-shadow: 0 0 35px rgba(255,255,255,0.65);
        }
        .pay-btn:active { transform: scale(0.95); }
        .pay-btn:hover svg { color: black; }

        /* Fix background attachment on iOS/mobile */
        .bg-fixed-hero {
          position: fixed;
          inset: 0;
          z-index: -10;
          background-image: url('${bgImage}');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
      `}</style>

      {/* Fixed background — stays behind everything while page scrolls */}
      <div className="bg-fixed-hero">
        <div className="absolute inset-0 bg-black bg-opacity-55" />
      </div>

      <NavBar />

      {/* Page wrapper — min-h so short content still fills screen */}
      <div className="relative min-h-screen">

        <div className="mx-6 mt-32 mb-12 relative z-10 border bg-black bg-opacity-30 backdrop-filter backdrop-blur-sm py-16 rounded-xl">
          <div className="container mx-auto px-6 max-w-5xl py-8 md:py-0">

          <h1 className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold fade-up-2 uppercase tracking-wide text-b pb-4 leading-none">
             {th("title")}
            </h1>
            <p className="text-sm text-gray-500 mb-8">
             {th("Last-updated")} 04-05-2026
            </p>

            <p className="text-white mb-6 leading-relaxed">
              {th("At")} <span className="font-semibold"> {th("Padel")}</span>,{th("t")}
            </p>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              1.  {th("t1")}
            </h2>
            <p className="text-white mb-4 leading-relaxed">
               {th("s1")}
            </p>
            <p className="text-white mb-6 leading-relaxed">
               {th("s12")}
            </p>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              2.  {th("t2")}
            </h2>
            <p className="text-white mb-4 leading-relaxed">
               {th("s2")}
            </p>
            <ul className="list-disc pl-6 space-y-2 text-white mb-6">
              <li> {th("l21")}</li>
              <li> {th("l22")}</li>
              <li> {th("l23")}</li>
            </ul>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              3.  {th("t3")}
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-white mb-6">
              <li> {th("l31")}</li>
              <li> {th("l32")}</li>
              <li> {th("l33")}</li>
              <li> {th("l34")}</li>
            </ul>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              4.  {th("t4")}
            </h2>
            <p className="text-white mb-4">
               {th("s4")}
            </p>
            <p className="text-white mb-4">
               {th("email")} <a href="mailto:contact@padelmasterthegame.com" className="text-primary hover:underline">contact@padelmasterthegame.com</a><br />
            </p>
            <p className="text-white mb-2"> {th("s41")}</p>
            <ul className="list-disc pl-6 space-y-2 text-white mb-6">
              <li> {th("l41")}</li>
              <li> {th("l42")}</li>
              <li> {th("l43")}</li>
              <li> {th("l44")}</li>
            </ul>
            <p className="text-white mb-6">
               {th("s42")}<span className="font-medium"> {th("s43")}</span>.
            </p>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              5. {th("t5")}
            </h2>
            <p className="text-white mb-6 leading-relaxed">
               {th("s5")}
            </p>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              6.  {th("t6")}
            </h2>
            <p className="text-white mb-4">
               {th("s6")}
            </p>
            <ul className="list-disc pl-6 space-y-2 text-white mb-6">
              <li> {th("l61")}</li>
              <li> {th("l62")}</li>
              <li> {th("l63")}</li>
            </ul>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              7.  {th("t7")}
            </h2>
            <p className="text-white mb-6 leading-relaxed">
               {th("s7")}
            </p>

            <h2 className="text-xl font-semibold text-b mt-8 mb-3">
              8.  {th("t8")}
            </h2>
            <p className="text-white mb-2">
               {th("s8")}
            </p>
            <p className="text-white">
             {th("email")} <a href="mailto:contact@padelmasterthegame.com" className="text-primary hover:underline">contact@padelmasterthegame.com</a><br />
            </p>

          </div>
        </div>
      </div>

      <Ende />
      <End />
    </>
  );
};

export default ContactForm;